export default __webpack_public_path__ + "static/media/membership_bonus_icon.176a4c18.svg";